import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Note";

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const Create = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const GetById = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const GetByUser = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetByUser`, options);

export const Update = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Delete = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export default {
  GetAll,
  Create,
  GetById,
  GetByUser,
  Update,
  Delete,
};
